import { generateSourcesForPicture } from '@farmersdog/corgi-x';

import jadaJpg from './jada-puppy.jpg';
import jadaWebP from './jada-puppy.webp';

export const jadaSources = generateSourcesForPicture({
  desktopSources: { webP: jadaWebP, jpg: jadaJpg },
  mobileSources: { webP: jadaWebP, jpg: jadaJpg },
});
